import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import InfoProcessing, { IProps } from './index';

const mapStateToProps = (state: ApplicationState): IProps => {
  return {
    sectionTitle: state.student.config.Checklist.Consents.shortTitle,
    currentStep: 2,
    steps: 3,
    consent: state.student.consents.isPage2Complete,
    config: state.student.config.Checklist.Consents,
  };
};

export default connect(mapStateToProps)(InfoProcessing);
